module.exports = __webpack_public_path__ + "img/main.d5094e01.jpg";